export default {
  set(state, { data }) {
    state.ownOrders = data;
  },
  show(state, { data }) {
    state.ownOrder = data;
  },
  getPage(state, { data }) {
    state.page = data
  }
}